import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

const testimonials = document.querySelectorAll('.testimonials .swiper');
console.log(testimonials)
if (testimonials) {
    testimonials.forEach((element) => {
        var id = element.id.replace('swiper-', '')
        var swiperid = "#swiper-" + id;
        new Swiper(swiperid, {
            modules: [Navigation],
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3
                },
            },
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: ".slidenext",
                prevEl: ".slideprev",
            }
        });
    })
}